<div class="loader-wrapper" [class.d-none]="!show">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
    <div class="loader-inner-1"></div>
  </div>
</div>
